import CommonCss from "nlib/common/common.module.scss";

import Css from "./style.module.scss";

import fallbackLogoSrc from "assets/business.svg";

import { getProjectName } from "selectors/organizations";
import { getSelectedBusinessData } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useDispatch, useSelector } from "react-redux";
import BusinessStatus from "nlib/common/BusinessStatus";
import Businesses from "utils/Businesses";
import IntegrationServices from "const/IntegrationServices";
import IntegrationsActions from "actions/IntegrationsActions";
import React, { useCallback } from "react";
import Texts from "utils/Texts";
import UiActions from "actions/UiActions";
import moment from "moment";

const Banner = () => {
  const dispatch = useDispatch();

  const { uiTexts } = useSelector(getTextsData);

  const {
    name: businessName,
    extraData: {
      integrationService,
      transactionsLastSyncedAt
    } = {},
    extraData = {},
    settings = {}
  } = useSelector(getSelectedBusinessData);

  const projectName = useSelector(getProjectName);

  const {
    logo: serviceLogo,
    label: serviceName
  } = IntegrationServices.getByValue(integrationService)
    || { logo: fallbackLogoSrc, label: projectName };

  const lastComplete = transactionsLastSyncedAt ? Texts.replaceVars(
    uiTexts.lastSyncDate,
    { date: moment.duration(moment.utc(transactionsLastSyncedAt).diff(moment.utc())).humanize(true) }
  ) : null;

  const quickBooksDesktopBusiness = integrationService === IntegrationServices.QUICK_BOOKS_DESKTOP.value;

  const handleReconnectClick = useCallback(async(event) => {
    event.preventDefault();
    if (quickBooksDesktopBusiness) {
      window.location.reload();
    } else {
      dispatch(UiActions.togglePreloader(true));

      const consentUrl = await dispatch(IntegrationsActions.buildConsentUrl(
        extraData.integrationService,
        { rpaMode: Businesses.checkIsRpaMode(extraData) }
      ));

      if (consentUrl) window.location.href = consentUrl;
      else dispatch(UiActions.togglePreloader(false));
    }
  }, [extraData, quickBooksDesktopBusiness, dispatch]);

  return (
    <div className={`${Css.banner} ${CommonCss.card}`}>
      <div className={Css.left}>
        <img title={serviceName} alt={serviceName} src={serviceLogo} />
        <div>
          <div className={Css.name}>{businessName}</div>
          <BusinessStatus
            extraData={extraData}
            settings={settings}
            onReconnectClick={handleReconnectClick} />
        </div>
      </div>
      <div className={Css.center}>{lastComplete}</div>
      <div className={Css.right} />
    </div>
  );
};

export default React.memo(Banner);
